import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Cookie from 'utils/cookies';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import Slider from 'react-slick';
import { loadGamesListingData } from '../../../redux';
import GameCard from '../GameCard/GameCard';
import s from './MoreOnGames.scss';

const MoreOnGames = props => {
  const {
    gameType,
    isMobile,
    gamesListing,
    gamesConfigData,
    userData,
    cardProps,
    isCogratulationsPage,
    gameId,
    gameLevel,
    moreOnGamesTitle,
  } = props;

  const tempgameTypeOrder = [
    'location_guesser',
    'mini_crossword',
    'loop_a_loop',
    'crossword',
    'sudoku',
    'whos_that',
  ];

  const userDataRef = useRef(userData);
  const ref = useRef(null);

  const [data, setData] = useState(false);

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
  };

  const getData = () => {
    if (typeof props.loadGamesListingData === 'function') {
      const ssoId = Cookie.get('ssoid') || Cookie.get('ssoId'); // '8t8n677gs25x9cyosnvl8tlwb'; //
      //   console.log('sso:', Cookie.get('ssoid'))
      const grxId = Cookie.get('_grx'); //'92b423b9-a141-361e-a0ea-81f3cedd2926'; //
      props.loadGamesListingData({
        grxId,
        ssoId,
        isWapView: false,
        clientSide: true,
      });
    }
  };

  useEffect(
    () => {
      if (
        userData &&
        userData.isLoggedIn !== userDataRef?.current?.isLoggedIn
      ) {
        getData();
      } else if (props.forceLoadDataOnInit) {
        getData();
      }
      userDataRef.current = userData;
    },
    [userData],
  );

  const getLocalStorageKeyPrefix = gameTypeVar => {
    switch (gameTypeVar) {
      case 'sudoku':
        return 'tilsudoku';
      case 'location-guesser':
        return 'tillocationguesser';
      case 'loop-a-loop':
        return 'tilloopaloop';
      default:
        return 'tilstate';
    }
  };

  useEffect(
    () => {
      if (
        isCogratulationsPage &&
        !(data && Array.isArray(data)) &&
        gamesListing &&
        gamesListing.items &&
        Array.isArray(gamesListing.items)
      ) {
        let { items } = gamesListing;

        // Step 1: Sort items based on tempgameTypeOrder before applying any further logic
        items.sort((a, b) => {
          const indexA = tempgameTypeOrder.indexOf(
            a?.gameCategoryData?.gameType,
          );
          const indexB = tempgameTypeOrder.indexOf(
            b?.gameCategoryData?.gameType,
          );
          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        });

        // Step 2: Apply additional sorting logic
        items = items.map(item => {
          const gameStatuses =
            item?.gameCategoryData?.gameStatus &&
            Array.isArray(item.gameCategoryData.gameStatus)
              ? item.gameCategoryData.gameStatus
              : [];

          const allFinished =
            gameStatuses.length > 0 &&
            gameStatuses.every(status => status.hasPlayed);
          const anyPaused = gameStatuses.some(status => status.hasPaused);
          const anyPausedInLocalStorage = gameStatuses.some(status =>
            localStorage.getItem(
              `${getLocalStorageKeyPrefix(item?.gameCategoryData?.gameType)}:${
                status.gameId
              }`,
            ),
          );

          let sortOrder;
          if (anyPaused || anyPausedInLocalStorage) {
            sortOrder = 1; // Paused games first
          } else if (allFinished) {
            sortOrder = 3; // Finished games last
          } else {
            sortOrder = 2; // Unfinished games in the middle
          }

          return { ...item, sortOrder };
        });

        // Step 3: Sort items again based on sortOrder while maintaining tempgameTypeOrder order
        items.sort((a, b) => a.sortOrder - b.sortOrder);

        setData(items);
      }
    },
    [gamesListing],
  );

  const renderGameCards = () =>
    data
      .filter(sectionItem => {
        if (
          sectionItem &&
          sectionItem.tn === 'gameCategory' &&
          sectionItem.gameCategoryData &&
          sectionItem.gameCategoryData.gameType
        ) {
          const tempGameType = sectionItem.gameCategoryData.gameType.replace(
            /_/g,
            '-',
          );
          const tempCalledGameType = gameType.replace(/_/g, '-');
          return tempGameType !== tempCalledGameType; // Exclude matching gameType
        }
        return false;
      })
      .map((sectionItem, index) => {
        let commonGameCardProps = {
          data: sectionItem.gameCategoryData,
          userData,
          ...cardProps,
        };
        const tempGameType2 = sectionItem.gameCategoryData.gameType.replace(
          /_/g,
          '-',
        );
        if (gamesConfigData) {
          const gameCategoryConfigData =
            gamesConfigData?.gameCategories &&
            gamesConfigData.gameCategories[
              sectionItem.gameCategoryData.gameType
            ];
          if (gameCategoryConfigData) {
            commonGameCardProps = {
              ...commonGameCardProps,
              gameCategoryConfigData,
            };
          }
        }
        return (
          <GameCard
            calledFrom="more_games_congratulations"
            key={tempGameType2}
            gameType={tempGameType2}
            {...commonGameCardProps}
            gameId={gameId}
            gameLevel={gameLevel}
            subSection={gameType}
            gaLabel={`position_${index + 1}`}
          />
        );
      });

  return (
    <>
      {moreOnGamesTitle && (
        <div className={s.moreOnGamesTitle}>
          <h2>{moreOnGamesTitle}</h2>
        </div>
      )}
      <div className={`${s.sliderWrap} slick_UI`}>
        {isCogratulationsPage &&
          data &&
          Array.isArray(data) &&
          (!isMobile ? (
            <Slider {...settings} ref={ref}>
              {renderGameCards()}
            </Slider>
          ) : (
            <div className={s.mobileScroll}>{renderGameCards()}</div>
          ))}
      </div>
    </>
  );
};

MoreOnGames.propTypes = {
  isMobile: PropTypes.bool,
  gamesListing: PropTypes.shape({}),
  gamesMetaWidget: PropTypes.shape({}),
  cardProps: PropTypes.shape({}),
  loadGamesListingData: PropTypes.func,
  forceLoadDataOnInit: PropTypes.bool,
  isCogratulationsPage: PropTypes.bool,
};

MoreOnGames.defaultProps = {
  isMobile: false,
  gamesListing: undefined,
  gamesMetaWidget: undefined,
  loadGamesListingData: () => {},
  cardProps: {},
  forceLoadDataOnInit: false,
  isCogratulationsPage: false,
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
  gamesListing: _get(state, 'toigames.gameslisting', {}),
  gamesConfigData: _get(state, 'toigames.gamesconfig', {}),
  userData: state.login.userData,
});

const mapDispatchToProps = dispatch => ({
  loadGamesListingData: (params, loaderCallback) => {
    dispatch(loadGamesListingData(params, loaderCallback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MoreOnGames);
